export default __webpack_public_path__ + "static/media/support.e4046546.svg";